(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bcp-header"] && !Shopify.designMode) return;
  try {
    
  const initOffers = () => {
    document.querySelectorAll('.bcp-announcement__offers').forEach(track => {
      if (track.dataset.sliderReady) return;
      track.dataset.sliderReady = 'true';
      const items = [...track.children];
      const region = track.parentElement;

      const mobile = matchMedia('(max-width: 640px)');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let index = 0;
      const render = () => items.forEach((item, i) => {
        item.classList.toggle('is-active', i === index);
        item.inert = mobile.matches && i !== index;
        if (mobile.matches && i !== index) item.setAttribute('aria-hidden', 'true');
        else item.removeAttribute('aria-hidden');
      });
      const advance = direction => { index = (index + direction + items.length) % items.length; render(); };
      region.querySelector('.bcp-offers-prev').addEventListener('click', () => advance(-1));
      region.querySelector('.bcp-offers-next').addEventListener('click', () => advance(1));
      mobile.addEventListener('change', render);
      render();
      const timer = setInterval(() => {
        if (!track.isConnected) { clearInterval(timer); mobile.removeEventListener('change', render); return; }
        if (!mobile.matches || reduced.matches || document.hidden) return;
        index = (index + 1) % items.length;
        render();
      }, 4500);
    });
  };
  const initDrawer = () => document.querySelectorAll('.bcp-mobile-nav').forEach(menu => {
    if (menu.dataset.drawerReady) return;
    menu.dataset.drawerReady = 'true';
    const dialog = menu.querySelector('dialog');
    const close = () => { dialog.close(); menu.open = false; };
    menu.addEventListener('toggle', () => {
      if (menu.open && !dialog.open) dialog.showModal();
      else if (!menu.open && dialog.open) dialog.close();
    });
    dialog.querySelector('.bcp-drawer-close').addEventListener('click', close);
    dialog.addEventListener('click', event => { if (event.target === dialog) {
      const r = dialog.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right) close();
    } });
    dialog.addEventListener('close', () => { menu.open = false; });
  });
  initDrawer();
  document.addEventListener('shopify:section:load', initDrawer);
  initOffers();
  document.addEventListener('shopify:section:load', initOffers);

  document.addEventListener('click', (event) => {
    document.querySelectorAll('.bcp-mobile-nav[open],.bcp-nav-dropdown[open]').forEach((menu) => {
      if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.bcp-mobile-nav[open],.bcp-nav-dropdown[open]').forEach((menu) => {
      menu.open = false;
      menu.querySelector('summary').focus();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
